import { ProductPackage } from '../../../types/package';
import { updatePackageTHeadData } from '../../../data/admin-data';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { useNewPackageManager } from '../../../hooks/packages/useNewPackageManager';
import { selectCurrentPackageItems } from '../../../features/package/packageSlice';
import { useSelector } from 'react-redux';
import { useInitializePackageForm } from '../../../hooks/packages/useInitializePackageForm';

interface UpdatePackageItemTBodyProps {
    typOfAction: "newPackage" | "updatePackage"
}

export default function UpdatePackageItemTBody({ typOfAction }: UpdatePackageItemTBodyProps) {
    
    const currentPackageItems = useSelector(selectCurrentPackageItems);
    const { handleRemoveProduct } = useNewPackageManager();
    const { isLoadingPackageData, isErrorPackageData, errorMessagePackageData } = useInitializePackageForm({typOfAction})
    
    const sortPackageItems = (items: ProductPackage[]) => {
        return [...items].sort((a, b) => {
            const catA = a.productCategory?.toLowerCase() || '';
            const catB = b.productCategory?.toLowerCase() || '';

            const catCompare = catA.localeCompare(catB);
            if (catCompare !== 0) return catCompare;

            const sizeA = a.productSize?.toLowerCase() || '';
            const sizeB = b.productSize?.toLowerCase() || '';

            if (sizeA === 'none' || sizeA === '') return 1;
            if (sizeB === 'none' || sizeB === '') return -1;

            if (sizeA.length !== sizeB.length) {
                return sizeA.length - sizeB.length;
            }

            return sizeA.localeCompare(sizeB);
        });
    };
    
    return (
        <tbody className='w-full'>
            {isLoadingPackageData ? (
                <tr>
                    <td colSpan={updatePackageTHeadData.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isErrorPackageData ? (
                <tr>
                    <td colSpan={updatePackageTHeadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessagePackageData} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : currentPackageItems.length === 0 ? (
                <tr>
                    <td colSpan={updatePackageTHeadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                sortPackageItems(currentPackageItems || []).map((productPack, index) => {
                    const firstWord = productPack?.productCategory?.split(" ")[0] || "";
                    const name = `${productPack?.productName}`
                    const addons = productPack.addons ?? [];
                    const isNew = productPack.typeOfAdd === 'new'
                    const type = productPack?.productType === 'NONE' ? '' : productPack?.productType
                    const category = (productPack?.productCategory === "null" || productPack?.productCategory === null) ? "" : productPack?.productCategory ?? ""
                    return (
                        <tr 
                            key={productPack.productId} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {name} 
                                        {isNew && (
                                            <span className="ml-2 inline-flex rounded bg-green-100 px-2 py-0.5 text-xs font-medium text-green-700">
                                                New
                                            </span>
                                        )}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {type}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {category}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {productPack?.productSize}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {productPack?.productPrice}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="col-span-2 mt-1 flex flex-col text-[11px] text-gray-600">
                                    {addons.map((add) => (
                                        <div key={add.addonID}>{add.addonName}</div>
                                    ))}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div
                                    onClick={() => handleRemoveProduct(productPack.productId)}
                                    className="text-red-500 hover:text-red-700 cursor-pointer flex justify-center"
                                    title="Delete"
                                >
                                    🗑️
                                </div>
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
